<template>
  <b-card no-body>
    <b-card-header class="bg-transparent border-0">
      <b-dropdown text=" Actions " variant="dark" slot="append">
        <b-dropdown-item>
          <json-excel
            :data="exportData"
            :fields="exportFields"
            type="xls"
            :name="fileName + '.xls'"
          >
            Export in Excel
          </json-excel>
        </b-dropdown-item>
        <b-dropdown-item>
          <json-excel
            :data="exportData"
            :fields="exportFields"
            type="csv"
            :name="fileName + '.csv'"
          >
            Export to CSV
          </json-excel>
        </b-dropdown-item>
      </b-dropdown>
    </b-card-header>

    <el-table
      class="table-responsive table"
      header-row-class-name="thead-light"
      :data="inquiries"
    >
      <el-table-column label="Contact Details" min-width="250px" prop="name">
        <template v-slot="{ row }">
          <span class="name mb-0">
            <b>{{ row.name }}</b>
            <br />
            <span class="text-sm">{{ row.email }}</span>
            <br />
            <span class="text-sm">{{ row.contactNo }}</span>
            <br />
          </span>
        </template>
      </el-table-column>

      <el-table-column label="Message" min-width="300px">
        <template v-slot="{ row }">
            <truncate
                :text="row.message"
                :lines="2"
                :show-truncate="true"
                :show-expand="true"
                :expand-text="'Show More'"
                :collapse-text="'Show Less'"
                :class="'secondary'"
              />
        </template>
      </el-table-column>

      <el-table-column label="Date Inquired" min-width="170px">
        <template v-slot="{ row }">
          <span class="mb-0 text-sm">{{ getDisplayDateTime(row.dateCreated) }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Status" min-width="150px" prop="status">
        <template v-slot="{ row }">
          <badge class="badge-dot mr-4" type="">
            <i :class="`bg-${row.statusType}`"></i>
            <span class="status" :class="`text-${row.statusType}`">{{ row.status }}</span>
          </badge>
        </template>
      </el-table-column>

      <el-table-column label="Actions" min-width="150px">
        <template v-slot="{ row }">
          <div v-if="row.status === 'DONE' || row.status === 'CANCELLED'">
            <i>No Actions Needed</i>
          </div>
          <div v-else>
            <b-button
              size="sm"
              variant="primary"
              @click="$emit('done-inquiry', row.id)"
              v-show="row.status !== 'DONE'"
              >Done</b-button
            >
            <b-button
              size="sm"
              variant="warning"
              @click="$emit('cancel-inquiry', row.id)"
              v-show="row.status !== 'DONE'"
              >Cancel</b-button
            >
          </div>
        </template>
      </el-table-column>
    </el-table>

    <b-card-footer class="py-4 d-flex justify-content-end">
      <base-pagination v-model="currentPage" :per-page="perPage" :total="totalRows" />
    </b-card-footer>
  </b-card>
</template>
<script>
import { Table, TableColumn } from "element-ui";

// Util
import { DateUtil } from "@/util/dateUtil";

// Others
import JsonExcel from "vue-json-excel";
import truncate from 'vue-truncate-collapsed';

export default {
  name: "inquiries-table",
  components: {
    JsonExcel,
    truncate,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    inquiries: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
    };
  },
  computed: {
    /**
     * Returns the set of data to be included in the export. For now this just
     * returns the data as is.
     *
     * @returns {Array} the set of data to be included in the export.
     */
    exportData() {
      return this.inquiries.map((inquiry) => {
        return {
          name: inquiry.name,
          email: inquiry.email,
          contactNo: inquiry.contactNo,
          message: inquiry.message,
          dateCreated: this.getDisplayDateTime(inquiry.dateCreated),
          status: inquiry.status,
        };
      });
    },

    /**
     * Derives the field information based from the data table configuration.
     *
     * @returns {object} the fields to be included in the export.
     */
    exportFields() {
      return {
        Name: "name",
        Email: "email",
        "Contact No": "contactNo",
        Message: "message",
        "Date Inquired": "dateCreated",
        Status: "status",
      };
    },

    fileName() {
      let currTimeStamp = DateUtil.getCurrentTimestamp();
      return "Inquiries-" + DateUtil.getDateInDDMMYYYYHHSSFormat(currTimeStamp);
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.totalRows = this.inquiries.length;
    });
  },
  methods: {
    // UTILS
    getDisplayDateTime(date) {
      if (date) {
        return DateUtil.getFormattedDateWithTime(date);
      }
      return "-";
    },
  },
};
</script>
